app.controller('HomeMenuCtrl', ['$rootScope', function($rootScope) {

}]);
